(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/prolong-list.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/prolong-list.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.ProlongList = Backbone.Marionette.CollectionView.extend({
    log: new svs.core.log.Logger('svs.maltipset.views.ProlongList'),
    childView: svs.maltipset.views.ProlongWager,
    tagName: 'ul',
    className: 'maltipset-prolong-list padding-0',
    emptyView: svs.maltipset.views.ProlongEmpty,
    initialize: function() {
      this.loader = new svs.components.Loader();
      this.moreItemsloader = new svs.components.Loader('.more-items-loader');
      this.listenTo(
        svs.maltipset.collections.coupons.getCurrentCoupon(),
        'wager:paySuccess',
        this.onPaymentSuccess,
        this
      );
    },
    onAttach: function() {
      var self = this;
      if (!this.collection.length && this.loader) {
        this.loader.show();
      }
      this.collection.on('sync', function() {
        self.loader.hide();
        self.loader = null;
      });
    },
    onScrollEnd: function() {
      if (this.collection.hasMoreItemsToFetch && !this.collection.isFetching) {
        var self = this;
        this.moreItemsloader.show(200, 'inverted');
        this.collection.getMoreItems(
          function() {
            self.moreItemsloader.hide();
          },
          function() {
            self.moreItemsloader.hide();
            svs.sport.sport_common.showErrorDialog(
              'Nu gick något fel',
              'Det gick inte att hämta några fler spel. Försök senare.'
            );
          }
        );
      }
    },
    onPaymentSuccess: function(wager) {
      svs.components.dialog.api.add(new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'my-games',
        title: 'Ditt spel är betalat',
        message: [
          {
            type: svs.components.dialog.message.TEXT,
            text: 'Ditt spel på Måltipset kostade <span class="nowrap">' + wager.get('totalCostFormatted') +
              ' kr.</span>. Du hittar det under Mina spel'
          }
        ],
        actions: [
          {
            title: 'Mina spel',
            callback: function() {
              location.href = svs.utils.urlMapping.get('myBetsHome');
            }
          },
          {
            title: 'OK'
          }
        ]
      }));

      svs.sport.sport_common.getContextualGrasrotenDialog()
        .then(function(dialog) {
          if (dialog) {
            svs.components.dialog.api.add(dialog);
          }
          return undefined;
        })
        .catch(function(error) {
          this.log.debug(error);
        });
    }
  });
})(Backbone, _, svs);

 })(window);